export default __webpack_public_path__ + "static/media/mozilla.895282d6.png";